export default "__VITE_ASSET__d721352b__"